define(["jquery", "history", "multiselect"], function ($, h, multiselect) {
    var originalTitle = document.title;
    var _currentPageQueryParameterKey;
    var _adminQueryParameterKey;
    var _summerjobsQueryParameterKey;
    var _searchtextQueryParameterKey;
    var _listElementSelector;
    var _queryStringKeyOrderBy;
    var _sortOrderElementSelector;
    var _searchInputSelector;
    var _summerJobsInputSelector;
    var clearFilterLinkSelector = ".js-clearfilter-link";

    var vacancyPage = {

        PageTitle: document.title,

        init: function (
            currentPageQueryParameterKey,
            adminQueryParameterKey,
            summerjobsQueryParameterKey,
            searchtextQueryParameterKey,
            queryStringKeyOrderBy,
            listElementSelector,
            sortOrderElementSelector,
            summerJobsInputSelector,
            searchInputElementSelector
        ) {

            //assign component variables
            _currentPageQueryParameterKey = currentPageQueryParameterKey;
            _adminQueryParameterKey = adminQueryParameterKey;
            _summerjobsQueryParameterKey = summerjobsQueryParameterKey;
            _searchtextQueryParameterKey = searchtextQueryParameterKey;
            _listElementSelector = listElementSelector;
            _queryStringKeyOrderBy = queryStringKeyOrderBy;
            _sortOrderElementSelector = sortOrderElementSelector;
            _summerJobsInputSelector = summerJobsInputSelector
            _searchInputSelector = searchInputElementSelector;


            multiselect.init(function (event) {
                // on administration option change. history update is intial and paging should be reset.
                vacancyPage.UpdateHistory(true, true);
            });

            if (window.History.enabled) {
                //hide button
                $("#filter .btn").hide();

                const isInitial = true;
                const isPagingReset = false;

                //Fix för att första sidladdningen utan querystring blir en dubblett i history-listan.
                vacancyPage.UpdateHistory(isInitial, isPagingReset);

                vacancyPage.SetupAjax();
            }
        },
        UpdateHistoryFromUrlParameters: function (currentUrl) {

            //remove anchorlink, urlparams set anchorlink as parameter value otherwise
            var currentUrlWithoutHash = new URL(currentUrl.split('#')[0]);

            //get querystring as object with url parameters
            const urlParams = new URLSearchParams(currentUrlWithoutHash.search);

            // collects values to a pattern &admin=1&admin=2 and so on.
            const administrations = urlParams.getAll(_adminQueryParameterKey);

            //assign to empty string to prevent "null" as value
            const search = urlParams.get(_searchtextQueryParameterKey) || "";
            const sortOrder = urlParams.get(_queryStringKeyOrderBy) || "";

            //set summerjob parameter value as bool
            const summerjobs = urlParams.get(_summerjobsQueryParameterKey) === "true";

            //reset paging
            const pageToSet = "1";

            //push url parameters to history
            vacancyPage.PushFilterStateToHistory(search, administrations, summerjobs, pageToSet, sortOrder);
        },
        ReplaceFilterStateHistory: function (
            search,
            administrations,
            summerjobs,
            pageToSet,
            sortOrder) {

            var history = window.History;
            var state = history.getState();
            state.title = search !== '' ? search + ' - ' + originalTitle : originalTitle;

            //admin values as query sting parameters
            var adminValues = $(administrations).map(function () { return '&' + _adminQueryParameterKey + '=' + this }).get().join('');
            var queryString = "?" + _searchtextQueryParameterKey + "=" + encodeURIComponent(search) + adminValues + "&" + _summerjobsQueryParameterKey + "=" + summerjobs + "&" + _currentPageQueryParameterKey + "=" + pageToSet + "&" + _queryStringKeyOrderBy + "=" + sortOrder;

            document.title = state.title;
            history.replaceState({ state: { vacancysearch: search, administration: administrations, summerjobs: summerjobs, _currentPageQueryParameterKey: pageToSet, _queryStringKeyOrderBy: sortOrder } }, state.title, queryString);
        },
        PushFilterStateToHistory: function (
            search,
            administrations,
            summerjobs,
            pageToSet,
            sortOrder) {

            var history = window.History;
            var state = history.getState();
            state.title = search !== '' ? search + ' - ' + originalTitle : originalTitle;

            //admin values as query sting parameters
            var adminValues = $(administrations).map(function () { return '&' + _adminQueryParameterKey + '=' + this }).get().join('');
            var queryString = "?" + _searchtextQueryParameterKey + "=" + encodeURIComponent(search) + adminValues + "&" + _summerjobsQueryParameterKey + "=" + summerjobs + "&" + _currentPageQueryParameterKey + "=" + pageToSet + "&" + _queryStringKeyOrderBy + "=" + sortOrder;

            history.pushState({
                state: {
                    vacancysearch: search,
                    administration: administrations,
                    summerjobs: summerjobs,
                    _currentPageQueryParameterKey: pageToSet,
                    _queryStringKeyOrderBy: sortOrder
                }
            }, state.title, queryString);
        },
        UpdateInputFields: function (historyState) {
            if (historyState.data !== null) {
                if (historyState.data.state.vacancysearch !== null) {
                    $(_searchInputSelector).val(decodeURIComponent(historyState.data.state.vacancysearch)); //J.R bakade in decode här, resterande koppling sköts av browsern.
                }
                else {
                    $(_searchInputSelector).val("");
                }

                if (historyState.data.state.administration !== null)
                    multiselect.setSelected(historyState.data.state.administration);

                if (historyState.data.state.summerjobs !== null && historyState.data.state.summerjobs) {
                    $(_summerJobsInputSelector)[0].selectedIndex = 1;
                }
                else {
                    $(_summerJobsInputSelector)[0].selectedIndex = 0;
                }
            }
        },
        UpdateResultList: function (historyState) {
            //TODO: Handle history-stuff
            var requestBaseUrl = historyState.url.indexOf('?') !== -1 ? historyState.url + "&isAjax=true" : historyState.url + "?isAjax=true";

            $.ajax({
                url: requestBaseUrl,
                cache: true,
                dataType: "html",
                success: function (response) {
                    $(_listElementSelector).html(response);
                },
                error: function (request, status, errorThrown) {
                    //console.log("epic fail: " + errorThrown + ", " + status);
                }
            });
        },
        //Pushes the "filter input control state" and "pagination info" into history
        UpdateHistory: function (createNewHistoryEntry, isPagingReset) {

            var administrations = multiselect.getSelectedValues();
            var search = $(_searchInputSelector).val();
            var summerjobs = $(_summerJobsInputSelector)[0].selectedIndex > 0;
            var sortOrder = $(_sortOrderElementSelector).val();

            const urlParams = new URLSearchParams(window.location.search);
            const currentPage = urlParams.get(_currentPageQueryParameterKey) || "";
            const pageToSet = isPagingReset ? "1" : currentPage;

            if (createNewHistoryEntry === false) {
                //Ser till att querystring är komplett vid första första sidladdningen och gör sedan replace på history entryt.
                vacancyPage.ReplaceFilterStateHistory(search, administrations, summerjobs, pageToSet, sortOrder);

            } else {
                vacancyPage.PushFilterStateToHistory(search, administrations, summerjobs, pageToSet, sortOrder);
            }
        },
        //Binds change eventhandlers to input controls
        //multiselect is setup in init function
        SetupAjax: function () {

            const isInitial = false;
            const isPagingReset = true;

            var timer;
            $(_searchInputSelector).keyup(function () {
                var delay = 500;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    vacancyPage.UpdateHistory(isInitial, isPagingReset);
                }, delay);
            });

            $(_summerJobsInputSelector).change(function () {
                vacancyPage.UpdateHistory(isInitial, isPagingReset);
            });

            //Use event delegation for dynamically created elements
            $(document).on("change", _sortOrderElementSelector, function () {
                vacancyPage.UpdateHistory(isInitial, isPagingReset);
            });

            //update history when clear filter link is clicked
            //a clear filter link contains a query string with the new "filter state"
            $(document).on("click", clearFilterLinkSelector, function (e) {
                e.preventDefault();
                var currentUrl = $(this).attr("href");
                vacancyPage.UpdateHistoryFromUrlParameters(currentUrl);
            });

            // binds to popstate that fires only when browser back/forward buttons are used
            History.Adapter.bind(window, "statechange", function () {
                var state = window.History.getState();

                //Uppdatera inmatningsfälten
                vacancyPage.UpdateInputFields(state);
                //Uppdatera resultatlistan
                vacancyPage.UpdateResultList(state);
            });
        }
    }
    return vacancyPage;
});